export default "__VITE_ASSET__B_2CoyfL__"